import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import DataTable from 'react-data-table-component';
import licenseService from '../../../Services/licenseService';

const POListTable = ({ refreshKey }) => {
    const { t } = useTranslation();
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(25);
    const [loading, setLoading] = useState(false);

    const fetchRows = useCallback(() => {
        setLoading(true);
        licenseService.listPOs({ page, limit })
            .then(res => {
                setRows(res.data.rows || []);
                setTotalRows(res.data.totalRows || 0);
            })
            .catch(err => console.log(err))
            .finally(() => setLoading(false));
    }, [page, limit]);

    useEffect(() => { fetchRows(); }, [fetchRows, refreshKey]);

    const columns = useMemo(() => [
        { name: t('PO Number'), selector: r => r.po_number, sortable: true },
        {
            name: t('Asset'),
            selector: r => r.po_property_id
                ? `${r.po_property_id.property_name} (${r.po_property_id.property_mall_code})`
                : '—',
            wrap: true, grow: 2
        },
        { name: t('Quantity'), selector: r => r.po_quantity, sortable: true },
        {
            name: t('Issue Date'),
            selector: r => r.po_issue_date ? new Date(r.po_issue_date).toLocaleDateString() : '—',
            sortable: true
        },
        {
            name: t('Created By'),
            selector: r => r.po_created_by
                ? (r.po_created_by.username || `${r.po_created_by.userFirstName || ''} ${r.po_created_by.userLastName || ''}`.trim())
                : '—'
        },
        {
            name: t('Created At'),
            selector: r => r.createdAt ? new Date(r.createdAt).toLocaleString() : '—',
            sortable: true
        }
    ], [t]);

    return (
        <div className='license-glass-card mt-3'>
            <div className='license-card-title'>{t('Purchase Orders')}</div>
            <div className='license-card-sub mb-2'>{t('All POs across every asset')}</div>
            <DataTable
                columns={columns}
                data={rows}
                progressPending={loading}
                pagination paginationServer
                paginationTotalRows={totalRows}
                onChangePage={p => setPage(p)}
                onChangeRowsPerPage={l => { setLimit(l); setPage(1); }}
                paginationPerPage={limit}
                highlightOnHover striped dense
            />
        </div>
    );
};

export default POListTable;
